import { fetchBaseQuery, createApi } from '@reduxjs/toolkit/query/react';
import { store } from '../../../store/store';


const baseUrl = process.env.REACT_APP_base_URL;

export const getInboxBusinessUserList = createApi({
    reducerPath: 'getInboxBusinessUserList',
    baseQuery: fetchBaseQuery({
      baseUrl: baseUrl,
      prepareHeaders: (headers) => {
        // const token = useSelector((state)=> state.user.token)
        const token = store.getState().user.token;
        if (token) {
          headers.set('Authorization', `Bearer ${token}`);
        }
        return headers;
    },
    }),
    endpoints: (builder) => ({
      fetchInboxBusinessUserList: builder.query({
        query: ({ userId, solutionId}) => ({
          url: `/inbox/solution_provider/${solutionId}`,
          method: 'GET',
        }),
        transformResponse: (response) => {
          if(response.status != "error"){
            return response.data
          }else{
           return  response = [];
          }
        },
        refetchOnWindowFocus: true,
        // retry: RetryOnError,
        onError: (error) => {
          console.error('Fetch user details error:', error);
          // Handle error cases as per your application's requirements
        },
      })
    })
})


export const { useFetchInboxBusinessUserListQuery } = getInboxBusinessUserList;
export default getInboxBusinessUserList;